import { render } from "./TMF2026_album.vue?vue&type=template&id=ad6cdc90&scoped=true"
import script from "./TMF2026_album.vue?vue&type=script&lang=js"
export * from "./TMF2026_album.vue?vue&type=script&lang=js"

import "./TMF2026_album.vue?vue&type=style&index=0&id=ad6cdc90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6cdc90"]])

export default __exports__